import React from 'react';
import styled from '@benzinga/themetron';

const CommentsCount = React.lazy(() =>
  import('@benzinga/comments-ui').then(module => ({ default: module.CommentsCount })),
);

export interface AuthorContentProps {
  commentCount?: number;
  isPartialView?: boolean;
  toggleCommentsDrawer?: () => void;
  url?: string;
}

export const CommentButton: React.FC<AuthorContentProps> = ({
  commentCount,
  isPartialView,
  toggleCommentsDrawer,
  url,
}) => {
  return (
    <Container className="article-comments-button">
      <CommentsCount
        commentMessage="Add Comment"
        count={commentCount}
        onClick={toggleCommentsDrawer}
        showMessage={true}
        url={isPartialView ? url : undefined}
      />
    </Container>
  );
};

const Container = styled.div`
  .comments-count-button {
    color: ${({ theme }) => theme.colorPalette.blue500};
    background-color: #3f83f81a;
    padding: 0.4rem 1.25rem;
    border-radius: 0.25rem;
    font-weight: 600;
    margin: auto;

    &:hover {
      background-color: #3f83f833;
    }
  }
`;
